import { FilterType } from "@domain/enums/FilterType";
import { FilterMapper } from "@app/routing/mappers/FilterMapper";
import { continentsAll } from "@studyportals/static-domain-data/continents/continents";
import { continentGetPath } from "@studyportals/static-domain-data/continents/continent-get-path";
import {IExtendedWithPortalTypeFilterValue} from "@app/routing/mappers/IExtendedWithPortalTypeFilterValue";

export class ContinentFilterMapper extends FilterMapper {
	public filterType: FilterType = FilterType.CONTINENT;
	public isMultiSelect = true;
	private static instance: ContinentFilterMapper;

	protected values: IExtendedWithPortalTypeFilterValue[] = [];

	public static getInstance(): ContinentFilterMapper {
		if (!ContinentFilterMapper.instance) {
			ContinentFilterMapper.instance = new ContinentFilterMapper();
		}
		return ContinentFilterMapper.instance;
	}

	private constructor() {
		super();

		const typedContinents = continentsAll as unknown as { id: number | string; name: string }[];

		for (const continent of typedContinents) {
			const virtualPath = continentGetPath(continent.id.toString());
			if (virtualPath) {
				this.values.push({
					id: continent.id.toString(),
					virtualPath,
					name: continent.name
				});
			}
		}
	}
}
